import { useRecruiterBookingFlowContext } from "../../hooks/useRecruiterBookingFlowContext";
import { RecruiterScreeningBookingLandingActions } from "./RecruiterScreeningBookingLandingActions";
import { RecruiterScreeningCallMeNowActions } from "./RecruiterScreeningCallMeNowActions";

export function RecruiterScreeningCallModalActions() {
  const { path } = useRecruiterBookingFlowContext();

  switch (path) {
    case "landing": {
      return <RecruiterScreeningBookingLandingActions />;
    }

    case "call-me-now": {
      return <RecruiterScreeningCallMeNowActions />;
    }

    case "schedule-for-later": {
      // Not implemented yet
      return null;
    }

    default: {
      return null;
    }
  }
}
